import React, { useEffect } from "react";

import CheckoutForm from "./CheckoutForm";
import FailToLoadPage from '../FailToLoadPage';
import { useLocation, useSearchParams } from 'react-router-dom';

function CCard(props) {
  const location = useLocation();
  try {
     const state = location.state;
    
    // Extract data from state
    const data = state?.data;
    const encrypt_data = state?.encrypt_data;
    const exist = state?.exist;
    const base64_data = state?.base64_data;


    if(!data) {
      console.log("Page crashed!");

    return (
      <FailToLoadPage
        encryptData={encrypt_data}
        message= {`Payment Failed: 80${Math.floor(Math.random()*(999-1+1)+1)}`}
        base64Data={base64_data}
      />
    );
    }

    return (
      <CheckoutForm
        data={data}
        encryptData={encrypt_data}
        exist={exist}
        base64Data={base64_data}
      />
    );
  } catch (error) {
    console.log(`error:${error}`);
  }
}

export default CCard;
